import { z } from 'zod';
import {
  firstNameValidationSchema,
  lastNameValidationSchema,
  phoneNumberValidationSchema,
} from '@/schemas/ValidationSchema.ts';

export const userDetailsSchema = z.object({
  name: firstNameValidationSchema,
  surname: lastNameValidationSchema,
  phoneNumber: phoneNumberValidationSchema,
});

export const companyDataSchema = z.object({
  companyName: z
    .string()
    .min(1, 'Nazwa firmy jest wymagana')
    .min(2, 'Nazwa firmy musi mieć co najmniej 2 znaki'),
});

export type UserDetailsFormData = z.infer<typeof userDetailsSchema>;
export type CompanyDataFormData = z.infer<typeof companyDataSchema>;
